const BASE_URL = "https://chuuchuu.com";

export interface PageSeoMeta {
  title: string;
  description: string;
  image: string;
  imageWidth: number;
  imageHeight: number;
  url: string;
  /** When true, the edge function leaves <link rel="canonical"> untouched.
   *  Use for dynamic pages to prevent search engines indexing infinite URLs. */
  skipCanonical?: boolean;
}

export const HEATWAVE_SEO: PageSeoMeta = {
  title: "How Heatwaves Disrupt European Trains | chuuchuu",
  description:
    "1397 days of extra train delays on days above 30°C during the June 2026 heatwave. Explore how heat impacted European rail punctuality.",
  image: `${BASE_URL}/images/WhenRailsMeltThumbnail.png`,
  imageWidth: 1292,
  imageHeight: 902,
  url: `${BASE_URL}/heatwave`,
};

export const WRAPPED_2025_SEO: PageSeoMeta = {
  title: "European Train Punctuality Rankings 2025 | chuuchuu Wrapped",
  description:
    "136 years of delays. Heatwaves and holidays. Swiss precision and German delays. Explore the 2025 rankings of European train punctuality by country.",
  image: `${BASE_URL}/images/Wrapped2025Thumbnail.png`,
  imageWidth: 1894,
  imageHeight: 1048,
  url: `${BASE_URL}/2025wrapped`,
};

export const WRAPPED_2024_SEO: PageSeoMeta = {
  title: "European Train Punctuality Rankings 2024 | chuuchuu Wrapped",
  description:
    "Explore the 2024 rankings of European train punctuality by country. Switzerland leads with 95% on-time trains, while Germany struggles at 54%. View detailed statistics on train lines and stations.",
  image: `${BASE_URL}/images/previewpage.jpg`,
  imageWidth: 1200,
  imageHeight: 628,
  url: `${BASE_URL}/2024wrapped`,
};

export const DATA_PAGE_SEO: PageSeoMeta = {
  title: "Train Delay Data | chuuchuu API",
  description:
    "Access European train delay analytics with our powerful API. Get real-time and historical data on train punctuality, delays, and cancellation rates.",
  image: `${BASE_URL}/images/departureboard.jpg`,
  imageWidth: 5229,
  imageHeight: 3338,
  url: `${BASE_URL}/data`,
};

export const APP_LANDING_SEO: PageSeoMeta = {
  title: "chuuchuu - Smart Rail Journey Planner for Europe | Better Than Zugfinder, Omio & Trainline",
  description:
    "chuuchuu provides real-time delay predictions, reliability scores, and live journey tracking for European train travel. Never miss a connection again.",
  image: `${BASE_URL}/images/previewpage.jpg`,
  imageWidth: 1200,
  imageHeight: 628,
  url: `${BASE_URL}/app`,
};

export const CONTACT_SEO: PageSeoMeta = {
  title: "Contact chuuchuu | Get in touch with our team",
  description:
    "Want to know more about chuuchuu's train delay data or analytics? Contact our team for information about our API, pricing, or partnership opportunities.",
  image: `${BASE_URL}/images/previewpage.jpg`,
  imageWidth: 1200,
  imageHeight: 628,
  url: `${BASE_URL}/contact`,
};

export const PRIVACY_SEO: PageSeoMeta = {
  title: "Privacy Policy | chuuchuu",
  description:
    "Learn how chuuchuu protects your privacy. Our privacy policy explains how we handle data when you use our train delay analytics service.",
  image: `${BASE_URL}/images/previewpage.jpg`,
  imageWidth: 1200,
  imageHeight: 628,
  url: `${BASE_URL}/privacy`,
};

export const TERMS_SEO: PageSeoMeta = {
  title: "Terms and Conditions | chuuchuu",
  description:
    "Read the Terms and Conditions for using chuuchuu's train delay analytics service. Learn about usage rules, service availability, intellectual property, and more.",
  image: `${BASE_URL}/images/previewpage.jpg`,
  imageWidth: 1200,
  imageHeight: 628,
  url: `${BASE_URL}/terms`,
};

export const IMPRINT_SEO: PageSeoMeta = {
  title: "Imprint | chuuchuu",
  description:
    "Legal information and company details for chuuchuu BV. Find our registration number, address, and contact information for chuuchuu train delay analytics.",
  image: `${BASE_URL}/images/previewpage.jpg`,
  imageWidth: 1200,
  imageHeight: 628,
  url: `${BASE_URL}/imprint`,
};

/** Keyed by route path — used by the Netlify edge function for static meta injection. */
export const PAGE_SEO_META: Record<string, PageSeoMeta> = {
  "/heatwave": HEATWAVE_SEO,
  "/2025wrapped": WRAPPED_2025_SEO,
  "/2024wrapped": WRAPPED_2024_SEO,
  "/data": DATA_PAGE_SEO,
  "/app": APP_LANDING_SEO,
  "/contact": CONTACT_SEO,
  "/privacy": PRIVACY_SEO,
  "/terms": TERMS_SEO,
  "/imprint": IMPRINT_SEO,
};
